import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Divider from 'antd/es/divider';

import colors from 'config/colors';

import Statistics from 'components/Statistics';
import Icon from 'components/Icon';

const StyledStatsCard = styled(Card)`
  background-color: #FFFFFF;
  border-radius: 8px;
  border: none;

  & .ant-card-body {
    padding: 8px;
    padding-bottom: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const StatsIconWrapper = styled.div`
  height: 46px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
`;

const statsCardStyles = {
  fontWeight: 600,
  fontSize: '38px',
  lineHeight: '46px',
};

const StatsCard = ({ title, value, valueLoads, valueUnloads, icon, color }) => {
  if (value === undefined || value === null) value = '-';
  if (valueLoads === undefined || valueLoads === null) valueLoads = '-';
  if (valueUnloads === undefined || valueUnloads === null) valueUnloads = '-';

  return (
    <StyledStatsCard>
      <Statistics
        title={title}
        titleAlign={['center', 'bottom']}
        value={value}
        valueStyle={{ color: colors.get(color) || color, ...statsCardStyles }}
        prefix={icon
          ? (
            <StatsIconWrapper>
              <Icon name={icon} size={24} />
            </StatsIconWrapper>
          ) : null
        }
      />
      <Divider type="horizontal" style={{ margin: '8px 0', minWidth: 'unset', width: 'calc(100% - 16px)' }} />
      <DirectionStatsWrapper>
        <Statistics
          title="Inbound"
          titleAlign={['center', 'bottom']}
          valueStyle={directionStatsValueStyles}
          value={valueUnloads}
        />
        <Divider type="vertical" style={{ height: '44px', margin: '0 2px' }} />
        <Statistics
          title="Outbound"
          titleAlign={['center', 'bottom']}
          valueStyle={directionStatsValueStyles}
          value={valueLoads}
        />
      </DirectionStatsWrapper>
    </StyledStatsCard>
  );
};

const directionStatsValueStyles = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#232526',
}


const DirectionStatsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  & .ant-statistic-title {
    font-size: 12px;
    line-height: 20px;
    color: #A4B0BA;
  }
`;

export default StatsCard;
